import axios from 'axios';

const api = axios.create({
  baseURL: (import.meta.env && import.meta.env.VITE_API_URL) || '/api',
  timeout: 12000
});

// Simple exponential backoff retry
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config || {};
    if (!cfg || cfg.__retry) {
      return Promise.reject(error);
    }
    const status = error.response?.status;
    const shouldRetry = !status || (status >= 500 && status < 600) || status === 429;
    if (!shouldRetry) return Promise.reject(error);

    cfg.__retry = (cfg.__retry || 0) + 1;
    if (cfg.__retry > 3) return Promise.reject(error);

    const delay = Math.min(1000 * Math.pow(2, cfg.__retry - 1), 8000);
    await new Promise((r) => setTimeout(r, delay));
    return api(cfg);
  }
);

export default api;

/* eslint-env browser */
// Network guard to normalize API endpoints to the correct domain (production).
// - Force any stray requests to legacy goldenlife domains or localhost:5000 to the configured API base
// - Set axios baseURL accordingly

(function () {
  try {
    const getBase = () => {
      try {
        // 1. Window override (highest priority)
        if (typeof window !== 'undefined' && window.__API_BASE_URL) {
          return String(window.__API_BASE_URL);
        }
        // 2. Detect based on current hostname
        const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '';
        if (host === 'localhost' || host === '127.0.0.1') {
          return 'http://localhost:5001';
        }
        // 3. Default to production server
        return 'https://printerserver.maticamexico.com.mx';
      } catch {
        return 'https://printerserver.maticamexico.com.mx';
      }
    };

    const API_BASE = getBase().replace(/\/$/, '');

    // Patch global fetch to rewrite unwanted hosts
    const originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        let url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url) {
          // Replace any legacy goldenlife domains with API_BASE
          if (/^https?:\/\/([a-z0-9-]+\.)*goldenlife\.mx\b/i.test(url)) {
            const pathIndex = url.indexOf('/', url.indexOf('//') + 2);
            const path = pathIndex > -1 ? url.substring(pathIndex) : '';
            url = API_BASE + path;
            if (typeof input === 'string') {
              input = url;
            } else {
              try { input = new Request(url, input); } catch { }
            }
          }
        }
      } catch { }
      return originalFetch(input, init);
    };

    // Configure axios baseURL if available
    if (window.axios && !window.axios.defaults.baseURL) {
      window.axios.defaults.baseURL = API_BASE;
    }

    // Expose helper for debugging
    window.__NETWORK_GUARD = { API_BASE };
    console.log('🛡️ NetworkGuard activo. API base:', API_BASE);
  } catch (e) {
    console.warn('NetworkGuard init error:', e && e.message);
  }
})();
